/**
 * Veluna Cart Drawer
 * Slide-out cart drawer for improved UX and conversion
 */

(function() {
  'use strict';

  var cartDrawer = null;
  var cartDrawerBackdrop = null;
  var isOpen = false;
  var isInitialized = false; // Prevent duplicate initialization

  /**
   * Initialize cart drawer
   */
  function initCartDrawer() {
    // Prevent duplicate initialization
    if (isInitialized) {
      console.log('Veluna Cart Drawer already initialized, skipping...');
      return;
    }
    
    // Create cart drawer if it doesn't exist
    if (!document.querySelector('.veluna-cart-drawer')) {
      createCartDrawer();
    }
    
    cartDrawer = document.querySelector('.veluna-cart-drawer');
    cartDrawerBackdrop = document.querySelector('.veluna-cart-drawer__backdrop');
    
    if (!cartDrawer) return;

    // Open cart drawer triggers
    var cartButtons = document.querySelectorAll('[data-cart-drawer-open], .veluna-header__cart, .veluna-btn[href*="/cart"]');
    cartButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        openCartDrawer();
      });
    });
    
    // Mark as initialized
    isInitialized = true;
    console.log('Veluna Cart Drawer initialized successfully');

    // Close cart drawer triggers
    var closeButtons = document.querySelectorAll('[data-cart-drawer-close]');
    closeButtons.forEach(function(button) {
      button.addEventListener('click', closeCartDrawer);
    });

    if (cartDrawerBackdrop) {
      cartDrawerBackdrop.addEventListener('click', closeCartDrawer);
    }

    // Close on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) {
        closeCartDrawer();
      }
    });

    // Load cart contents
    loadCartContents();
  }

  /**
   * Create cart drawer HTML structure
   */
  function createCartDrawer() {
    var drawerHTML = `
      <div class="veluna-cart-drawer" aria-hidden="true" role="dialog" aria-modal="true" aria-label="Shopping cart">
        <div class="veluna-cart-drawer__backdrop" data-cart-drawer-close></div>
        <div class="veluna-cart-drawer__panel">
          <div class="veluna-cart-drawer__header">
            <h2 class="veluna-heading-md">Your Cart</h2>
            <button type="button" class="veluna-cart-drawer__close" data-cart-drawer-close aria-label="Close cart">
              ×
            </button>
          </div>
          <div class="veluna-cart-drawer__content">
            <div class="veluna-cart-drawer__items" data-cart-items>
              <!-- Cart items will be loaded here -->
            </div>
            <div class="veluna-cart-drawer__empty" data-cart-empty style="display: none;">
              <p class="veluna-body">Your cart is empty</p>
              <a href="/pages/ritual-essentials" class="veluna-btn veluna-btn-primary">Continue Shopping</a>
            </div>
          </div>
          <div class="veluna-cart-drawer__footer" data-cart-footer>
            <div class="veluna-cart-drawer__subtotal">
              <span class="veluna-cart-drawer__subtotal-label">Subtotal</span>
              <span class="veluna-cart-drawer__subtotal-price" data-cart-subtotal>$0.00</span>
            </div>
            <a href="/checkout" class="veluna-btn veluna-btn-primary veluna-cart-drawer__checkout">
              Checkout
            </a>
            <p class="veluna-body-muted veluna-cart-drawer__shipping-note">
              Shipping, taxes, and discounts calculated at checkout
            </p>
          </div>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', drawerHTML);
  }

  /**
   * Open cart drawer
   */
  function openCartDrawer() {
    if (!cartDrawer) return;
    
    cartDrawer.classList.add('veluna-cart-drawer--open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    isOpen = true;
    
    // Load fresh cart contents
    loadCartContents();
    
    // Track event
    trackEvent('cart_drawer_opened');
  }

  /**
   * Close cart drawer
   */
  function closeCartDrawer() {
    if (!cartDrawer) return;
    
    cartDrawer.classList.remove('veluna-cart-drawer--open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    isOpen = false;
    
    // Track event
    trackEvent('cart_drawer_closed');
  }

  /**
   * Load cart contents via AJAX
   */
  function loadCartContents() {
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        renderCartContents(cart);
      })
      .catch(function(error) {
        console.error('Error loading cart:', error);
      });
  }

  /**
   * Render cart contents
   */
  function renderCartContents(cart) {
    var itemsContainer = document.querySelector('[data-cart-items]');
    var emptyContainer = document.querySelector('[data-cart-empty]');
    var footer = document.querySelector('[data-cart-footer]');
    var subtotal = document.querySelector('[data-cart-subtotal]');
    
    if (!itemsContainer || !emptyContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.style.display = 'none';
      emptyContainer.style.display = 'block';
      if (footer) footer.style.display = 'none';
      return;
    }

    itemsContainer.style.display = 'block';
    emptyContainer.style.display = 'none';
    if (footer) footer.style.display = 'block';

    // Render cart items
    var itemsHTML = cart.items.map(function(item) {
      if (window.VelunaBonusGift && window.VelunaBonusGift.isGiftItem &&
          window.VelunaBonusGift.isGiftItem(item)) {
        return window.VelunaBonusGift.giftLineHTML(item);
      }
      // ONETIME_LABEL_FIX_VCART: include cart-level discounts + one-time pack labels
      var subscriptionHTML = '';

      var originalLinePrice = item.original_line_price || (item.price * item.quantity);
      var actualLinePrice = item.line_price || item.final_line_price || (item.price * item.quantity);
      var discountAmount = 0;
      if (item.discounts && item.discounts.length > 0) {
        for (var di = 0; di < item.discounts.length; di++) {
          discountAmount += (item.discounts[di].amount || 0);
        }
      } else if (originalLinePrice > actualLinePrice) {
        discountAmount = originalLinePrice - actualLinePrice;
      }
      var hasDiscount = discountAmount > 0;

      var priceHTML = formatMoney(actualLinePrice);

      if (item.selling_plan_allocation) {
        var spa = item.selling_plan_allocation;
        var discount = (spa.selling_plan && spa.selling_plan.price_adjustments && spa.selling_plan.price_adjustments[0]) ? spa.selling_plan.price_adjustments[0].value : 0;

        if (discount > 0) {
          subscriptionHTML = '<div style="display:flex;align-items:center;gap:4px;margin-top:2px;"><span style="font-size:0.7rem;font-weight:600;color:#8A5518;background:rgba(138,85,24,0.10);padding:1px 6px;border-radius:3px;white-space:nowrap;">Save ' + discount + '%</span></div>';
        }

        var compareAt = spa.compare_at_price;
        var salePrice = spa.price;
        if (compareAt && compareAt > salePrice) {
          priceHTML = '<span style="color: #8A5518; font-weight: 600;">' + formatMoney(salePrice) + '</span> <span style="text-decoration: line-through; color: #999; font-size: 0.8125rem;">' + formatMoney(compareAt) + '</span>';
        } else {
          priceHTML = formatMoney(salePrice);
        }
      } else if (hasDiscount) {
        var saleLine = originalLinePrice - discountAmount;
        priceHTML = '<span style="color: #8A5518; font-weight: 600;">' + formatMoney(saleLine) + '</span> <span style="text-decoration: line-through; color: #999; font-size: 0.8125rem;">' + formatMoney(originalLinePrice) + '</span>';
        var savePct = Math.round((discountAmount * 100) / originalLinePrice);
        if (savePct > 0) {
          subscriptionHTML = '<div style="display:flex;align-items:center;gap:4px;margin-top:2px;"><span style="font-size:0.7rem;font-weight:600;color:#8A5518;background:rgba(138,85,24,0.10);padding:1px 6px;border-radius:3px;white-space:nowrap;">Save ' + savePct + '%</span></div>';
        }
      }

      var packProp = item.properties && item.properties['Pack'];
      var typeProp = item.properties && item.properties['Type'];
      var variantHTML = '';
      if (packProp) {
        variantHTML = '<p class="veluna-body-muted" style="font-weight:500;color:#8A5518;">' + packProp + (typeProp ? ' - ' + typeProp : '') + '</p>';
      } else if (!item.selling_plan_allocation && item.variant_title && item.variant_title.indexOf('Month Delivery') !== -1) {
        var qtySets = item.quantity || 1;
        variantHTML = '<p class="veluna-body-muted" style="font-weight:500;color:#8A5518;">' + qtySets + (qtySets === 1 ? ' Set' : ' Sets') + ' - ' + item.variant_title + '</p>';
      } else if (item.variant_title) {
        variantHTML = '<p class="veluna-body-muted">' + item.variant_title + '</p>';
      }

      return `
        <div class="veluna-cart-drawer__item" data-cart-item-id="${item.id}">
          <div class="veluna-cart-drawer__item-image">
            <img src="${item.image}" alt="${item.product_title}" loading="lazy">
          </div>
          <div class="veluna-cart-drawer__item-details">
            <h3 class="veluna-heading-sm">${item.product_title}</h3>
            ${variantHTML}
            ${subscriptionHTML}
            <div class="veluna-cart-drawer__item-price">
              ${priceHTML}
            </div>
            <div class="veluna-cart-drawer__item-quantity">
              <button type="button" class="veluna-cart-drawer__quantity-btn" data-cart-decrease="${item.id}">−</button>
              <span class="veluna-cart-drawer__quantity-value">${item.quantity}</span>
              <button type="button" class="veluna-cart-drawer__quantity-btn" data-cart-increase="${item.id}">+</button>
            </div>
          </div>
          <button type="button" class="veluna-cart-drawer__item-remove" data-cart-remove="${item.id}" aria-label="Remove item">
            ×
          </button>
        </div>
      `;
    }).join('');

    itemsContainer.innerHTML = itemsHTML;

    // The perks card lives in veluna-bonus-gift.js so every renderer shows the
    // same one. Idempotent, so it is safe even if this renderer already drew it.
    if (window.VelunaBonusGift && window.VelunaBonusGift.appendPerks) {
      window.VelunaBonusGift.appendPerks(itemsContainer, cart);
    }

    // Update subtotal
    if (subtotal) {
      subtotal.textContent = formatMoney(cart.total_price);
    }

    // Attach event listeners
    attachCartItemListeners();
  }

  /**
   * Attach event listeners to cart items
   */
  function attachCartItemListeners() {
    // Quantity increase
    document.querySelectorAll('[data-cart-increase]').forEach(function(button) {
      button.addEventListener('click', function() {
        var itemId = button.getAttribute('data-cart-increase');
        updateCartItem(itemId, 1);
      });
    });

    // Quantity decrease
    document.querySelectorAll('[data-cart-decrease]').forEach(function(button) {
      button.addEventListener('click', function() {
        var itemId = button.getAttribute('data-cart-decrease');
        updateCartItem(itemId, -1);
      });
    });

    // Remove item
    document.querySelectorAll('[data-cart-remove]').forEach(function(button) {
      button.addEventListener('click', function() {
        var itemId = button.getAttribute('data-cart-remove');
        removeCartItem(itemId);
      });
    });
  }

  /**
   * Update cart item quantity
   */
  function updateCartItem(itemId, change) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemId,
        quantity: change
      })
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      renderCartContents(cart);
      updateCartCount(cart.item_count);
      trackEvent('cart_item_updated', { item_id: itemId, quantity: change });
    })
    .catch(function(error) {
      console.error('Error updating cart:', error);
    });
  }

  /**
   * Remove cart item
   */
  function removeCartItem(itemId) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemId,
        quantity: 0
      })
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      renderCartContents(cart);
      updateCartCount(cart.item_count);
      trackEvent('cart_item_removed', { item_id: itemId });
    })
    .catch(function(error) {
      console.error('Error removing cart item:', error);
    });
  }

  /**
   * Update cart count in header
   */
  function updateCartCount(count) {
    var cartCounts = document.querySelectorAll('.veluna-header__cart-count, [data-cart-count]');
    cartCounts.forEach(function(element) {
      element.textContent = count;
      element.style.display = count > 0 ? 'block' : 'none';
    });
  }

  /**
   * Format money
   */
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  /**
   * Track analytics event
   */
  function trackEvent(eventName, eventData) {
    // Google Analytics 4
    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, {
        event_category: 'cart',
        ...eventData
      });
    }

    // Facebook Pixel
    if (typeof fbq !== 'undefined') {
      fbq('track', 'AddToCart', eventData || {});
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }

  // Expose API
  window.VelunaCartDrawer = {
    open: openCartDrawer,
    close: closeCartDrawer,
    load: loadCartContents
  };

})();

